<template>
  <div>
    <el-row :style='{ width: "100%", height: height, "min-height": "250px"}' class="echarts">
      <IEcharts theme="vintage" :option="pieOptions" :resizable="true" v-if="pieOptions !== null"/>
    </el-row>
  </div>
</template>

<script>
    import 'echarts/theme/vintage.js'
  import IEcharts from 'vue-echarts-v3/src/full.js';
  import { store } from '../scripts/store.js';
  import { events } from '../scripts/events.js'
  import { repeatFrequency, exponentiateNum } from '../scripts/utils.js';
  const _ = require('lodash');

  export default {
    name: 'ModalUnitPieDistribution',
    props: {
      index: Number,
      height: String,
      series: Object,
    },
    components: { IEcharts },
    asyncComputed: {
      pieOptions: function () {
        const title = this.series.title;
        let series = this.series.data;
        series = series.map((d) => {
            return {
                type: 'pie',
                data: series,
                radius: ['40%', '70%'],
                center: ['50%', '55%'],
                label: { normal: { show: false } },
                labelLine: { normal: { show: false } }
            }
        })
        const options = {
            title: { text: title },
            backgroundColor: 'white', 
            tooltip: {
                backgroundColor: 'rgba(240, 240, 240, 0.8)',
                textStyle: {
                    align: 'left',
                    color: 'rgba(50, 50, 50, 0.8)'
                }
            },
            legend: {
                textStyle: { color: 'black' },
                show: true,
            },
            series: series,
            animation: true,
        }
        return new Promise(resolve => setTimeout(() => resolve(options), this.index * store.settings.plotUpdateDelayFactor))
      }
    
    },
    methods: {
      handleModalOpen: function () {
        events.$emit('open-modal', 'ModalBarFrequency')
      }
    }
  }
</script>


